var chunkToChildrenMap = {
	"5439": [
		796
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));